module.exports = __webpack_public_path__ + "gu.a454a4bdd17075d651c1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gu.svg
// module chunks = styles